/**
 * Splits templates into active and archived groups for the template
 * combobox. `flat` is the keyboard-navigation order: active first,
 * then archived, original order preserved within each group.
 */
export function groupTemplatesForDisplay(templates = []) {
  const active = [];
  const archived = [];
  templates.forEach((template) => {
    (template?.archived ? archived : active).push(template);
  });
  return { active, archived, flat: [...active, ...archived] };
}
